import { useConnect } from "wagmi";

const ConnectButton = () => {
  const { connect, connectors } = useConnect();
  return (
    <button
      className="button-flat connect-btn"
      onClick={() => connect({ connector: connectors[0] })}
    >
      Connect Wallet
    </button>
  );
};

export default ConnectButton;
